import { render, staticRenderFns } from "./userHeader.vue?vue&type=template&id=e0279efc&scoped=true&"
import script from "./userHeader.vue?vue&type=script&lang=js&"
export * from "./userHeader.vue?vue&type=script&lang=js&"
import style0 from "./userHeader.vue?vue&type=style&index=0&id=e0279efc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0279efc",
  null
  
)

export default component.exports